import { Save, Search } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import Api from "../../../api2";
import { commonReducerSelector, userSelector } from "../../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  ThongBao,
  scrollToError
} from "../../Lib/componentLibrarys";
import { FormInputData, FormNhap } from "./form";
import { ValidateSchema } from "./validate";
import { parseDataSave } from "./models";

const RoutesPhanQuyenChucNang = [
  {
    path: "",
    main: () => <PhanQuyenChucNang />
  }
];
export default RoutesPhanQuyenChucNang;

function PhanQuyenChucNang() {
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const formRef = useRef(null);
  const formInputDataRef = useRef(null);
  const [linhVucList, setLinhVucList] = useState([]);
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile?.data;
  const refI = useRef(null);

  useEffect(() => {
    if (isEmpty(linhVucList)) {
      new Api().GetDM_LinhVucs({}).then(data => {
        if (data.code === 200) {
          setLinhVucList(data?.data?.result?.data);
        }
      });
    }
  }, []);

  useEffect(() => {
    if (formRef.current) {
      formRef.current.resetForm({ values: { fieldChucNangs: data } });
    }
  }, [data]);

  //set initial data
  const initialState = {
    fieldChucNangs: data
  };

  //List form

  const formNhap = (
    <Formik
      key={JSON.stringify(data)}
      innerRef={f => (formRef.current = f)}
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
          />
        </form>
      )}
    </Formik>
  );
  const formInputData = (
    <Formik
      innerRef={f => (formInputDataRef.current = f)}
      initialValues={{linhVuc: null, app: null, role: null}}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormInputData
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
            linhVucList={linhVucList}
            profile={profile}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpdateFunctionByRoleId({
        data: parseDataSave(formRef?.current?.values?.fieldChucNangs),
        roleId: formInputDataRef?.current?.values?.role?.id
      })
      .then(res => {
        if (!res || res.code !== 200) {
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: "Thành công" });
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  const handleSearch = async () => {
    await formInputDataRef.current.validateForm();

    if (!isEmpty(formInputDataRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }
    setIsLoading(true)
    new Api()
      .GetFunctionByRoleId({ appId: formInputDataRef?.current?.values?.app?.id, roleId: formInputDataRef?.current?.values?.role?.id })
      .then(data => {
        if (data.code === 200) {
          setData(data?.data?.result);
        }
      })
      .catch(err => {})
      .finally(() => {
        setIsLoading(false)
      });
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Quản trị hệ thống" },
            { name: "Phân quyền chức năng" }
          ]}
        />
        {formInputData}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 10,
          }}
        >
          <MyButton
            onClick={handleSearch}
            txt="Tìm kiếm"
            style={{ width: 130, height: 33, marginTop: 5 }}
            icon={<Search />}
          />
        </div>
        { isLoading &&
          <div className="style-loading">
            <CircularProgress />
          </div>
        }
        { data &&
          <>
            {formNhap}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: 15,
                marginLeft: 25
              }}
            >
              <MyButton
                onClick={handleSave}
                txt="Lưu thông tin"
                style={{ width: 130, height: 33, marginTop: 5 }}
                icon={<Save />}
              />
            </div>
          </> 
        }
      </div>
    </>
  );
}
